<template>
    <div class="rounded-md p-4" :class="{
        'bg-yellow-50': alert,
        'bg-red-50': error,
        'bg-green-50': success,
        'bg-blue-50': loading || info,
    }">
        <div class="flex">
            <div class="flex-shrink-0">
                <i
                    class="h-5 w-5 fa-light fa-sharp"
                    :class="{
                        'text-blue-500': info,
                        'text-yellow-500': alert,
                        'text-red-500': error,
                        'text-green-500': success,
                        'text-blue-500 fa-spin': loading,
                        'fa-triangle-exclamation': alert,
                        'fa-circle-info': info,
                        'fa-circle-check': success,
                        'fa-circle-notch': loading,
                        'fa-circle-xmark': !loading && !success && !info && !alert
                    }"
                    aria-hidden="true"
                />
            </div>
            <div class="ml-3">
                <h3
                    class="text-sm font-medium"
                    :class="{
                        'text-yellow-800': alert,
                        'text-red-800': error,
                        'text-green-800': success,
                        'text-blue-800': loading || info,
                    }"
                    v-text="header"
                />
                <TranslateText :text="headerTrans"/>
                <div
                    v-if="body"
                    class="mt-2 text-sm"
                    :class="{
                        'text-yellow-700': alert,
                        'text-red-700': error,
                        'text-green-700': success,
                        'text-blue-700': loading || info,
                    }"
                >
                    <p v-text="body"/>
                    <TranslateText :text="bodyTrans"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import TranslateText from "@/components/TranslateText.vue";

const props = defineProps({
    alert: Boolean,
    info: Boolean,
    success: Boolean,
    error: Boolean,
    loading: Boolean,
    header: String,
    body: String,
    headerTrans: String,
    bodyTrans: String,
});

const icon = computed(() => {
    if (props.alert) {
        return 'fa-triangle-exclamation';
    }

    if (props.info) {
        return 'fa-circle-info';
    }

    if (props.success) {
        return 'fa-circle-check';
    }

    if (props.loading) {
        return 'fa-circle-notch';
    }

    return 'fa-circle-xmark';
});
</script>
